module.exports = __webpack_public_path__ + "img/animate-3.3f3aa132.png";